import { MUTATION_TYPES } from './types';

export const mutations = {
  [MUTATION_TYPES.SET_RESOURCES](state, resources) {
    state.resources = {
      ...state.resources,
      ...resources,
    };
  },
  [MUTATION_TYPES.SET_CURRENT_ACADEMIC_YEAR](state, academicYear) {
    state.currentAcademicYear = academicYear;
  },
};
